import { useState, type ClipboardEvent } from 'react';
import { LiliTextInput } from '../LiliTextInput';
import { useMask } from '@react-input/mask';
import { DEFAULT_MASK_CONFIG, type LiliCustomMask } from '../../types/Mask';
import type { LiliInputBaseProps } from '../../types/LiliInputBaseProps';
import { formatWithMask } from '../../util';

export interface ILiliMaskedInputV2Props extends LiliInputBaseProps {
  value?: string;
  mask: LiliCustomMask;
  onChange: (value: string) => void;
  onPaste?: (event: ClipboardEvent<HTMLInputElement>) => void;
  hint?: string;
}

// Full Documentation: https://www.npmjs.com/package/@react-input/mask
export const LiliMaskedInputV2 = ({
  mask,
  value,
  onChange,
  showClear,
  hint,
  ...restOfProps
}: ILiliMaskedInputV2Props) => {
  const inputRef = useMask({
    ...DEFAULT_MASK_CONFIG,
    mask,
  });

  const [inputValue, setInputValue] = useState(formatWithMask(value ?? '', mask));

  const handleChange = (eventValue: string) => {
    const formattedValue = formatWithMask(eventValue ?? '', mask);
    setInputValue(formattedValue);
    onChange(eventValue);
  };

  const getShowClearValue = () => {
    if (showClear !== undefined) {
      return showClear;
    }
    return true;
  };

  return (
    <LiliTextInput
      hint={value && value?.length > 0 ? undefined : hint}
      showClear={getShowClearValue()}
      ref={inputRef}
      value={inputValue}
      onChange={handleChange}
      {...restOfProps}
    />
  );
};
